export const isPlatinumApp = (app) => !!app.publisher.level?.includes('Platinum');
export const isGoldApp = (app) => !!app.publisher.level?.includes('Gold');
export const isSilverApp = (app) => !!app.publisher.level?.includes('Silver');

export const getPartnerRank = (app) => {
  if (isGoldApp(app)) {
    return 1;
  } else if (isPlatinumApp(app)) {
    return 2;
  } else if (isSilverApp(app)) {
    return 3;
  } else {
    return 4;
  }
};

export const sortByPartnerLevelPayGrade = (a, b) => getPartnerRank(a) - getPartnerRank(b);
